export const validateSixDigitPhoneNumber = (phoneNumber) => {
  const errors = [];
  const phoneRegex = /^\d{6}$/; // Regex for exactly 6 digits

  if (!phoneRegex.test(phoneNumber)) {
    errors.push("الرقم غير مناسب، يجب أن يكون الرقم مكون من 6 أرقام.");
  }

  return errors;
};
